// Forward-looking accessibility: upcoming / under-construction MRT lines.
//
// A curated snapshot of publicly-announced LTA rail projects (Jurong Region
// Line, Cross Island Line, TEL extensions) mapped to the towns / postal
// districts they serve. Proximity to a future station is one of the strongest
// price and desirability drivers, and it's a *forward-looking* signal the
// backward-looking timing model can't see — so we surface it alongside, not
// baked into, the entry score.
//
// Dates and station locations are indicative (per LTA announcements) and shift;
// treat as directional. No scraping — this is static public information.

export interface UpcomingRail {
  line: string;
  abbr: string;
  year: number; // indicative opening year (stage)
  districts: number[]; // postal districts served
  towns: string[]; // HDB towns served (upper-case, matching HDB_TOWNS)
  areas: string; // human-readable station/area list
}

export const UPCOMING_MRT: UpcomingRail[] = [
  {
    line: "Jurong Region Line", abbr: "JRL", year: 2027,
    districts: [22, 23, 24],
    towns: ["JURONG WEST", "JURONG EAST", "CHOA CHU KANG", "BUKIT BATOK"],
    areas: "Choa Chu Kang, Bukit Batok West, Tengah, Jurong West, Boon Lay",
  },
  {
    line: "Jurong Region Line", abbr: "JRL", year: 2029,
    districts: [22, 24],
    towns: ["JURONG WEST", "JURONG EAST"],
    areas: "Pandan Reservoir, Jurong Pier, western stretch",
  },
  {
    line: "Cross Island Line", abbr: "CRL", year: 2030,
    districts: [17, 18, 19, 20],
    towns: ["PASIR RIS", "TAMPINES", "HOUGANG", "SERANGOON", "ANG MO KIO"],
    areas: "Pasir Ris, Tampines North, Defu, Hougang, Serangoon North, Ang Mo Kio, Bright Hill",
  },
  {
    line: "Cross Island Line", abbr: "CRL", year: 2032,
    districts: [5, 21, 22],
    towns: ["CLEMENTI", "BUKIT BATOK"],
    areas: "Turf City, King Albert Park, Clementi, West Coast, Jurong Lake District",
  },
  {
    line: "Thomson-East Coast Line (Changi extension)", abbr: "TEL", year: 2040,
    districts: [17],
    towns: ["PASIR RIS", "CHANGI"],
    areas: "Loyang, Changi Airport T5",
  },
];

export function mrtForDistrict(d: number): UpcomingRail[] {
  return UPCOMING_MRT.filter((r) => r.districts.includes(d));
}
export function mrtForTown(town: string): UpcomingRail[] {
  const t = town.toUpperCase();
  return UPCOMING_MRT.filter((r) => r.towns.includes(t));
}

// Compact badge string, e.g. "🚉 CRL ~2030". Empty if none.
export function mrtBadge(rails: UpcomingRail[]): string {
  if (rails.length === 0) return "";
  const earliest = [...rails].sort((a, b) => a.year - b.year)[0];
  const others = rails.length > 1 ? ` +${rails.length - 1}` : "";
  return `🚉 ${earliest.abbr} ~${earliest.year}${others}`;
}
